import "reactflow/dist/style.css";

import { SidebarProvider } from "./components/SidebarFlow/context";
import { FlowNodesProvider } from "./context/FlowNodesProvider";
import FlowComponent from "./FlowComponet";

const Flow = ({ onNodesUpdate, onEdgesUpdate, ...props }) => {
  return (
    <FlowNodesProvider {...props}>
      <SidebarProvider>
        <FlowComponent
          {...(props || {})}
          onNodesUpdate={onNodesUpdate}
          onEdgesUpdate={onEdgesUpdate}
        />
      </SidebarProvider>
    </FlowNodesProvider>
  );
};

export default Flow;
